import axios from "@/services/api";
import UserService from "@/services/UserService";

export default class FileService {

    private userService = new UserService();

    public async getFiles(skip: number = 0, starred: boolean = false) {
        try {
            const response = await axios.get(
                `/api/v1/files/?skip=${skip}&starred=${starred}`,
                this.getHeaders());
            return response.data;
        } catch (error) {
            return 0;
        }
    }

    public async searchFiles(tag: string = "null", query: string = "null", skip = 0) {
        try {
            const response = await axios.get(
                `/api/v1/search/?tags=${tag}&query=${query}&skip=${skip}`,
                this.getHeaders());
            return response.data;
        } catch (error) {
            return 0;
        }
    }

    public async getTags() {
        try {
            const response = await axios.get(
                `/api/v1/tags/`,
                this.getHeaders());
            return response.data;
        } catch (error) {
            return 0;
        }
    }

    public async getFile(key: string) {
        // try {
        //     const response = await axios.get(
        //         `/api/v1/file/?key=${key}`,
        //         this.getHeaders());
        //     return response.data;
        // } catch (error) {
        //     return 0;
        // }


        return await axios.post("/api/v1/file/", { key }, {
            headers: {
                'Authorization': 'Token ' + this.userService.getSelf().token,
                'Content-Type': 'application/json'
            }
        });
    }

    public async uploadFile(formData: any) {
        // await axios.request({
        //     url: "/api/v1/upload/",
        //     method: 'POST',
        //     data: formData,
        //     headers: {
        //         'Authorization': 'Token ' + this.userService.getSelf().token,
        //         'Content-Type': 'multipart/form-data'
        //     },
        //     responseType: 'blob'
        // }).then(({ data }) => {

        // });

        await axios.post("/api/v1/upload/", formData, {
            headers: {
                'Authorization': 'Token ' + this.userService.getSelf().token,
                'Content-Type': 'multipart/form-data'
            }
        });
        // .then(() => {
        //     return { status: 'success' };
        // }).catch(() => {
        //     return { status: 'failure' };
        // });
    }

    public async editMetaData(uuid: any, title: any, tags: any, pubDate: any, author: any) {
        await axios.post("/api/v1/editmeta/", {
            uuid,
            title,
            tags,
            pubDate,
            author
        }, {
            headers: {
                'Authorization': 'Token ' + this.userService.getSelf().token,
                'Content-Type': 'application/json'
            }
        });
    }

    public async starFile(uuid: any) {
        return await axios.post("/api/v1/star/", {
            uuid
        }, {
            headers: {
                'Authorization': 'Token ' + this.userService.getSelf().token,
                'Content-Type': 'application/json'
            }
        });
    }

    private getHeaders() {
        return {
            headers: {
                'Authorization': 'Token ' + this.userService.getSelf().token,
                'Content-Type': 'application/json'
            }
        };
    }
}
